<template>
  <div class="surewrap dialog-con"><!-- v-show="ApplyInfo.isShow"-->
    <div class="dialog-con-bg"></div>
    <div class="dialog-warp">
        <div class="logo">
            <img src="@/assets/ic_logo.png">
        </div>
        <div class="surecon font-MT text-333 f-tac">
          <slot name="surecon"></slot>
        </div>
        <slot name='optionbox'></slot>
    </div>
    <div class="dialog-close" @click="closelogin()">
      <img src="../../assets/login/ic_close.png"/>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closelogin () {
      this.$emit('closesure', false)
    }
  }
};
</script>

<style lang="scss" scoped>
.surewrap{
    .dialog-warp {
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
        width: 730px;
        height: 401px;
        border-radius: 33px;
        .title{
            margin-top: 70px;
        }
        .surecon-detail{
            display: inline-block;
            margin: auto;
            margin-top: 37px;
            width: 640px;
            height: 146px;
            background: #F8F9FD;
            border-radius: 18px;
        }
        .logo{
            width: 96px;
            height: 96px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -49px;
        }
    }
}
</style>
